import React from 'react';
import Slider from 'react-slick';
// eslint-disable-next-line no-unused-vars
import slickcss from 'slick-carousel/slick/slick.css';
import Section from 'components_library/organisms/Section/Section';
import StoryList from 'components_library/templates/StoryList/StoryList';

const StoryListWebWrapper = props => (
  <StoryList
    {...props}
    SectionWrapperComponent={Section}
    SliderComponent={Slider}
  />
);

export default StoryListWebWrapper;
